<template>
  <div class="row ma-0 pa-0">
    <TextFieldFormatadorDeValor
      v-model="qtde_periodo_dias"
      inteiro
      removerValorIrrelevante
      :error-messages="qtdePeriodoDiasErrors"
      :propsVuetify="{
        outlined: true,
        label: `Enviar relatório para os emails de ${qtde_periodo_dias} em ${qtde_periodo_dias} dias`,
        suffix: 'dias'
      }"
      @input="$v.qtde_periodo_dias.$touch()"
      @blur="$v.qtde_periodo_dias.$touch()"
      @focus="ev => ev.target.select()"
      @keyup.enter="salvar()"
    />

    <SysBtn
      :size="2"
      class="ml-2 mb-7 px-5"
      @click="salvar()"
    >
      <span v-text="'Salvar'" />
    </SysBtn>
  </div>
</template>

<script>
import Api from "@/api/api";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  components: { TextFieldFormatadorDeValor },
  data: () => ({
    qtde_periodo_dias: 1
  }),
  validations: {
    qtde_periodo_dias: { required, minValue: minValue(1), }
  },
  computed: {
    qtdePeriodoDiasErrors() {
      const errors = [];
      if (!this.$v.qtde_periodo_dias.$dirty) return errors;
      !this.$v.qtde_periodo_dias.required && errors.push("Campo Obrigatório.");
      !this.$v.qtde_periodo_dias.minValue && errors.push("Valor informado deve ser maior ou igual a um (1)");
      return errors;
    }
  },
  methods: {
    salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      Api.post('diagnostico/clientes/inatividade-vendas/configuracao-email/salvar-periodicidade', { qtde_periodo_dias: this.qtde_periodo_dias });
    }
  }
}

</script>
